import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { ArcheHeader } from '../../../components/ArcheHeader';
import { LcNav } from '../components/LcNav';
import { PoolListPage } from './PoolListPage';
import { PoolDetailPage } from './PoolDetailPage';
import { MyPositionsPage } from './MyPositionsPage';
import { AdminPage } from './AdminPage';

/**
 * Arche wrapper for Liquidity Caches — provides ArcheLayout with sidebar
 * and handles sub-routing for all pool pages.
 */
export function LiquidityCachesArchePage() {
  return (
    <ArcheLayout>
      <div className="flex flex-col h-full">
        <ArcheHeader archeId="arche_liquidity_caches" title="Liquidity Caches" />
        <div className="flex-1 overflow-auto p-6">
          <LcNav />
          <Routes>
            <Route path="/" element={<PoolListPage />} />
            <Route path="/positions" element={<MyPositionsPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/:poolId" element={<PoolDetailPage />} />
          </Routes>
        </div>
      </div>
    </ArcheLayout>
  );
}
